<template>
  <div class="childOrder">
    <!-- eslint-disable-next-line vue/no-mutating-props -->
    <el-tabs v-model="echoParams.childActiveName"
      type="card"
      @tab-click="handleTab"
      >
      <el-tab-pane
        v-for="(item, index) of c_enterpriseTabsList"
        :label="`${item.label}(${item.number})`"
        :name="item.name"
        :key="index"
      />
    </el-tabs>
    <base-list-management
      ref="baseListManagement"
      :configData.sync="c_childOrderConfigData"
      >
      <PublicExport
        slot="custom-export"
        v-if="judgePermission('for_rent_sign_contract_ent_rent_order_sub_export')"
        exportTitle="导出"
        exportTemplate="LeaseOrderSub"
        :getSearchData="searchParams"
        templateCode="vehicle-workbench-ent-rent-sub-order"
        :getSearchCondition="getSearchCondition"
      />
      <div slot="custom-operate">
        <el-button
          type="primary"
          size="small"
          class="whole_contract_btn"
          v-if="
            judgePermission('for_rent_sign_contract_ent_rent_order_sub_add_car')
          "
          @click="enterSign"
          >企业签约提车
        </el-button>
      </div>
    </base-list-management>
  </div>
</template>

<script>
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import { searchByCustomerName } from '@/api/domain/customers'
// 配置
// eslint-disable-next-line import/no-cycle
import config from '../config'
import { getLeasingSchemeConfigListAll } from '@/api/domain/cars'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  props: {
    echoParams: {
      type: Object,
      default: () => ({}),
    },
    summaryList: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const {
      // 模版数据
      c_childOrderConfigData,
      // tabsList
      c_enterpriseTabsList,
    } = config.call(this)
    return {
      c_enterpriseTabsList,
      c_childOrderConfigData,
      // 客户列表
      customerConditionList: [],
      // 车牌号列表
      carIdConditionList: [],
    }
  },
  watch: {
    summaryList: {
      handler(val) {
        this.c_enterpriseTabsList.forEach((item) => {
          if (item.name === '1') {
            // 全部
            item.number = val.toProcessOrderNum
            return
          }
          if (item.name === '12') {
            // 发车待验车
            item.number = val.confirmedOrderNum
            return
          }
          if (item.name === '13') {
            // 订单待支付
            item.number = val.toPaymentOrderNum
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    // 客户模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    customerRemoteMethod(query) {
      if (query.length >= 1) {
        searchByCustomerName({
          customerState: 1,
          customerType: 2,
          customerName: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'customerId',
            data,
          })
        })
      }
    },
    async getPlanList() {
      // orderType(类型) - 1:个人; 2:企业;
      const res = await getLeasingSchemeConfigListAll({ orderType: 1 })
      const data = res?.data || []
      const customerOption = {
        name: '自定义',
        id: 0,
      }
      data.unshift(customerOption)
      this.$refs.baseListManagement.setItemData({
        elConfigKey: 'list',
        key: 'planId',
        data,
      })
    },
    // 企业签约提车
    enterSign() {
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
      })
    },
    // 退车解约
    // eslint-disable-next-line vue/no-unused-properties
    closeTheCar(row) {
      const query = {
        id: row.id,
        state: row.state,
        type: 5,
        returnInfoType: 2,
        orderType: 'enterChild',
      }
      const path = '/car_to_lease/forRentSignContract/subCancelContract'
      this.$router.push({
        path,
        query,
      })
    },
    // 查看财务进度
    // eslint-disable-next-line vue/no-unused-properties
    financeProgress(row) {
      const { id } = row
      const query = { orderId: id, stepActive: 3 }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
        query,
      })
    },
    // 发车验车
    // eslint-disable-next-line vue/no-unused-properties
    outInBankPop(row) {
      const { id } = row
      const query = { orderId: id, stepActive: 4 }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterSiginProcess',
        query,
      })
    },
    // 详情
    // eslint-disable-next-line vue/no-unused-properties
    toOrderDetailPage(row) {
      const query = {
        id: row.id,
        orderType: 'enterChild',
      }
      this.$router.push({
        path: '/car_to_lease/forRentSignContract/enterpriseChildDetail',
        query,
      })
    },
    // 车牌号模糊查询
    // eslint-disable-next-line vue/no-unused-properties
    carRemoteMethod(query) {
      if (query.length >= 4) {
        FuzzySearch({
          state: 1,
          plateNo: query,
        }).then((res) => {
          const { data } = res
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'carId',
            data,
          })
        })
      }
    },
    // tabs切换
    handleTab() {
      this.$refs.baseListManagement.reset()
    },
    // eslint-disable-next-line vue/no-unused-properties
    dealWithSearch(val) {
      // 发车验车时间
      val.outStockTimeStart = (val.TheCarExTime && val.TheCarExTime[0]) || ''
      val.outStockTimeEnd = (val.TheCarExTime && val.TheCarExTime[1]) || ''
      // 订单创建时间
      val.createTimeStart = (val.startTime && val.startTime[0]) || ''
      val.createTimeEnd = (val.startTime && val.startTime[1]) || ''
      // 免租结束日
      val.presentEntTimeStart =
        (val.presentEntTime && val.presentEntTime[0]) || ''
      val.presentEntTimeEnd =
        (val.presentEntTime && val.presentEntTime[1]) || ''
      // 计租结束日
      val.rentEndTimeStart = (val.rentFinIsh && val.rentFinIsh[0]) || ''
      val.rentEndTimeEnd = (val.rentFinIsh && val.rentFinIsh[1]) || ''
      // 个人租赁订单固定参数
      val.bizType = 20 // 10个人订单 20企业子订单
      val.relatedType = 10 // 无关联原因
      val.tabNo = Number(this.echoParams.childActiveName) // tab
      // 品牌车系车型
      const { brandSeriesModel } = val
      val.brandId = brandSeriesModel.brandId
      val.seriesId = brandSeriesModel.seriesId
      val.modelId = brandSeriesModel.modelId
      delete val.brandSeriesModel
      return val
    },
    getRouteQuery() {
      const { deptId } = this.echoParams

      if (deptId) {
        this.c_childOrderConfigData.formData.formProps.model.deptIdList = [deptId]
      }
    },
    init() {
      this.getRouteQuery()
      // 回显
      this.$set(
        this.c_childOrderConfigData.formData.formProps.model,
        'entRentOrderId',
        this.echoParams.entRentOrderId,
      )
      // 获取租赁方案list(公司和集团)
      this.getPlanList()
    },
    searchParams() {
      return this.$refs.baseListManagement?.getParams() || {}
    },
    getSearchCondition() {
      const params = this.searchParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const conditions = this.c_childOrderConfigData.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        if (key === 'customerId') {
          item.elConfig.options.list = this.customerConditionList
        }
        if (key === 'carId') {
          item.elConfig.options.list = this.carIdConditionList
        }
        const val = params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      // Tab需要放入导出的查询条件中
      conditions.push({
        label: '订单类型',
        matchValue: '企业租赁子订单',
      })
      conditions.push({
        label: '订单状态',
        matchValue: this.c_enterpriseTabsList.find((item) => String(item.name) === this.echoParams.childActiveName)?.label,
      })
      return conditions
    },
  },
}
</script>
